/**
 * Produto da Só Marcas (SM Revenda) com gravação informada pelo fornecedor: é o
 * que habilita a "Tabela fornecedor do produto" na gravação do item.
 */
export const hasSomarcasEngraving = product =>
    product?.origin === 'integracao_somarcas' && (product?.somarcas_engraving_price ?? 0) > 0;

/**
 * Gravação da Só Marcas por faixa de quantidade (BDM-1212). Produto sincronizado
 * antes da grade só tem o valor único (`somarcas_engraving_price`), que vale
 * para qualquer quantidade.
 *
 * Entre faixas que cobrem a quantidade vale a de menor intervalo, a mesma regra
 * do custo do produto. Abaixo da primeira faixa não há preço: a Só Marcas não
 * informa gravação abaixo do mínimo do produto.
 */
export const getSomarcasEngravingPrice = (product, quantity) => {
    const ranges = Array.isArray(product?.somarcas_engraving_prices) ? product.somarcas_engraving_prices : null;

    if (!ranges || ranges.length === 0) {
        return { price: product?.somarcas_engraving_price || 0, found: true };
    }

    let found = null;

    ranges.forEach(range => {
        if (quantity < range.init_quantity || quantity > range.final_quantity) return;

        const size = range.final_quantity - range.init_quantity;

        if (found === null || size < found.final_quantity - found.init_quantity) {
            found = range;
        }
    });

    return found ? { price: found.price, found: true } : { price: 0, found: false };
};
